import { render, staticRenderFns } from "./lci-lca.vue?vue&type=template&id=65f39301&scoped=true&"
import script from "./lci-lca.vue?vue&type=script&lang=js&"
export * from "./lci-lca.vue?vue&type=script&lang=js&"
import style0 from "./lci-lca.vue?vue&type=style&index=0&id=65f39301&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f39301",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAutocomplete,VCol,VRow,VSelect,VTextField})
